import { Expose, plainToInstance, Transform, Type } from "class-transformer";
import { ConsumableDto } from "@/core/features/consumables/consumable.dto";
import { get } from "lodash";
import { toEuros } from "@/utils/numberUtils";

export class ConsumableHistoryDto {
  @Expose()
  @Transform(({ obj }) => get(obj, "Consumable_id"))
  id: string;

  @Expose()
  @Transform(({ obj }) => {
    const consumableKeys = Object.keys(obj).filter((key) => key.startsWith("Consumable_"));
    const consumableData = consumableKeys.reduce((acc, key) => {
      const newKey = key.replace("Consumable_", "");
      const value = newKey === "externalReferences" ? mapExternalReferences(obj[key]) : obj[key];
      Object.assign(acc, { [newKey]: value });
      return acc;
    }, {});
    return plainToInstance(ConsumableDto, consumableData);
  })
  consumable: ConsumableDto;

  @Expose()
  @Type(() => Number)
  totalQuantity: number;

  @Expose()
  @Type(() => Number)
  @Transform(({ value }) => toEuros(value))
  averagePrice: number;

  @Expose()
  @Type(() => Number)
  @Transform(({ value }) => toEuros(value))
  totalCost: number;
}

function mapExternalReferences(value: unknown): { externalReference: string }[] {
  if (!value) return [];
  if (Array.isArray(value)) return value as { externalReference: string }[];

  return String(value)
    .split(",")
    .map((externalReference) => externalReference.trim())
    .filter((externalReference) => !!externalReference)
    .map((externalReference) => ({ externalReference }));
}
